<template>
  <v-app light class=" grey lighten-4">
    <v-toolbar color="white">
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <section>
        <v-parallax src="//source.unsplash.com/kZvmEpyfiJs" height="600">
          <v-layout
                  column
                  align-center
                  justify-center
          >
<!--            <img src="assets/vuetify.png" alt="Vuetify.js" height="200">-->
            <h1 class="font-weight-black mb-2 display-1 text-xs-center">DEEP WORK HOURS</h1>
            <div class="font-weight-black headline mb-4 text-xs-center">A tool designed for you to practise deep work activities.</div>
            <div id="firebaseui-auth-container" class="text-center"><span class="font-weight-black caption">version 0.5-beta</span></div>
          </v-layout>
        </v-parallax>
      </section>

      <section>
        <v-layout
                column
                wrap
                class="my-12"
                align-center
        >
          <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
              <h2 class="headline">Features</h2>
            </div>
          </v-flex>
          <v-flex xs12>
            <v-container grid-list-xl>
              <v-layout row wrap align-center>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-img
                            class="white--text"
                            height="200px"
                            src="@/assets/features-timer.png"
                    >
                    </v-img>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Pomodoro Timer</div>
                    </v-card-title>
                    <v-card-text class="text-center">
                      A pomodoro timer starts your deep work routine.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-img
                            class="white--text"
                            height="200px"
                            src="@/assets/features-calendar.png"
                    >
                    </v-img>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline">Calendar</div>
                    </v-card-title>
                    <v-card-text class="text-center">
                      A calendar keep tracks which day you practise deep work activities.
                    </v-card-text>
                  </v-card>
                </v-flex>
                <v-flex xs12 md4>
                  <v-card flat class="transparent">
                    <v-img
                            class="white--text"
                            height="200px"
                            src="@/assets/features-hour.png"
                            contain
                    >
                    </v-img>
                    <v-card-title primary-title class="layout justify-center">
                      <div class="headline text-center">Hour view</div>
                    </v-card-title>
                    <v-card-text class="text-center">
                      A chart keep tracks which hour you practise deep work activities.
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </section>

      <v-footer color="blue darken-2">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <div class="white--text ml-4">
              Made by <a class="white--text" href="https://www.instagram.com/just4sky/" target="_blank">Sky Chin</a>
            </div>
          </v-flex>
        </v-layout>
      </v-footer>
    </v-content>
  </v-app>
</template>

<script>
import { ui, auth } from '../main'
import firebase from '@firebase/app'
import * as firebaseui from 'firebaseui'

export default {
  name: 'Login',
  data: function (){
    return {
      isLoggedIn: false,
      title: 'DEEP WORK HOURS'
    };
  },
  mounted: function () {
    this.$ga.page('/login');

    ui.start('#firebaseui-auth-container', {
      callbacks: {
        signInSuccessWithAuthResult: () => {
          return false;
        }
      },
      // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
      signInFlow: 'redirect',
      autoUpgradeAnonymousUsers: false,
      signInOptions: [
        // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID
      ],
      // Required to enable one-tap sign-up credential helper.
      credentialHelper: firebaseui.auth.CredentialHelper.GOOGLE_YOLO
    });

    auth.onAuthStateChanged((user) => {
      if (user) {
        this.$router.push({ path: `/focus` })
      }
    });
  }
}
</script>

<style>
  @import url('../../node_modules/firebaseui/dist/firebaseui.css');

  .home-hero {
    background: url('http://source.unsplash.com/kZvmEpyfiJs');
    background-size: cover;
    width: 100%;
    height: 100%;
  }
</style>
